export const routes = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "About",
    path: "/about",
  },
  {
    name: "Menu",
    path: "/menu",
  },
  {
    name: "Reservations",
    path: "/reservations",
  },
  {
    name: "Order",
    path: "/order",
  },
  {
    name: "Login",
    path: "/login",
  },
];

export const highlights = [
  {
    title: "Greek salad",
    price: "12.99",
    description:
      "The famous greek salad of crispy lettuce, peppers, olives and our Chicago style feta cheese, garnished with crunchy garlic and rosemary croutons.",
    image: "/images/greek-salad.jpg",
  },
  {
    title: "Bruschetta",
    price: "5.99",
    description:
      "Our Bruschetta is made from grilled bread that has been smeared with garlic and seasoned with salt and olive oil.",
    image: "/images/bruchetta.svg",
  },
  {
    title: "Lemon Dessert",
    price: "5.00",
    description:
      "This comes straight from grandma’s recipe book, every last ingredient has been sourced and is as authentic as can be imagined.",
    image: "/images/lemon-dessert.jpg",
  },
];


export const testimonials = [
  {
    name: "Emily B.",
    image: "/images/Emily.JPG",
    feedback: "Nice and cozy place where you can eat the best food.",
  },
  {
    name: "Haithem M.",
    image: "/images/Haithem.JPG",
    feedback: "Exceptional service and delicious dishes!",
  },
  {
    name: "Naomi X.",
    image: "/images/Naomi.JPG",
    feedback: "Outstanding flavors and a delightful dining experience.",
  },
  {
    name: "Zack E.",
    image: "/images/Zack.JPG",
    feedback: "Fantastic ambiance and top-notch culinary offerings!",
  },
];